import { createContext } from "react";

type AutomcompleteContextValue = {
  hasMoreOptions: boolean;
  fetchNextPage: VoidFunction;
  isLoadingOptions: boolean;
};

export const AutocompleteContext = createContext<AutomcompleteContextValue>({
  isLoadingOptions: false,
  hasMoreOptions: false,
  fetchNextPage: () => {},
});
